var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.25,
    height: 14,
    viewBox: "0 0 12.25 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash",
    d: "M8.094-.437a.193.193,0,0,1-.219-.219V-8.094a.193.193,0,0,1,.219-.219h.438a.193.193,0,0,1,.219.219V-.656a.193.193,0,0,1-.219.219Zm-4.375,0A.193.193,0,0,1,3.5-.656V-8.094a.193.193,0,0,1,.219-.219h.438a.193.193,0,0,1,.219.219V-.656a.193.193,0,0,1-.219.219ZM12.031-10.5a.193.193,0,0,1,.219.219v.438a.193.193,0,0,1-.219.219h-.656V.438a1.266,1.266,0,0,1-.383.93,1.266,1.266,0,0,1-.93.383H2.188a1.266,1.266,0,0,1-.93-.383A1.266,1.266,0,0,1,.875.438V-9.625H.219A.193.193,0,0,1,0-9.844v-.437A.193.193,0,0,1,.219-10.5H3.063l.93-1.23a1.285,1.285,0,0,1,.465-.369,1.285,1.285,0,0,1,.574-.15H7.219a1.285,1.285,0,0,1,.574.15,1.285,1.285,0,0,1,.465.369l.93,1.23Zm-7.355-.711-.52.711H8.094l-.52-.711a.441.441,0,0,0-.355-.164H5.031A.441.441,0,0,0,4.676-11.211ZM10.5.438V-9.625H1.75V.438a.421.421,0,0,0,.438.438h7.875A.421.421,0,0,0,10.5.438ZM5.906-.437a.193.193,0,0,1-.219-.219V-8.094a.193.193,0,0,1,.219-.219h.438a.193.193,0,0,1,.219.219V-.656a.193.193,0,0,1-.219.219Z",
    transform: "translate(0 12.25)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.fae0051d6c2506ddc1daf7f9d5101b10.svg";
export { ForwardRef as ReactComponent };